import React from "react";
import {
  Area,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from "recharts";
import { useApp } from "../../../contexts/AppContext";

interface ProgressionChartProps {
  fertilization: number;
  cleavage: number;
  blastocyst: number;
}

const ProgressionChart: React.FC<ProgressionChartProps> = ({
  fertilization,
  cleavage,
  blastocyst,
}) => {
  const { translate } = useApp();

  const data = [
    {
      name: translate("oocyte", "report.progressionChart.fertilization"),
      value: fertilization,
    },
    {
      name: translate("oocyte", "report.progressionChart.cleavage"),
      value: cleavage,
    },
    {
      name: translate("oocyte", "report.progressionChart.blastocyst"),
      value: blastocyst,
    },
  ];
  return (
    <ResponsiveContainer width="100%" height={400}>
      <AreaChart data={data}>
        <defs>
          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#7C3AED" stopOpacity={1} />
            <stop offset="100%" stopColor="#EDE9FE" stopOpacity={1} />
          </linearGradient>
        </defs>
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip label={translate("oocyte", "report.progressionChart.value")} />
        <Area
          type="monotone"
          dataKey="value"
          stroke="#7C3AED"
          strokeWidth={3}
          fill="url(#colorUv)"
          fillOpacity={0.4}
          isAnimationActive={true}
          dot={{ stroke: "#7C3AED", strokeWidth: 2, r: 5 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default ProgressionChart;
